// extracted by mini-css-extract-plugin
export var hidden = "_ov-1";
export var visible = "_ov-0";